import { faqs } from "constant/staticData";
import useShimmer from "hooks/useShrimmer";

import React, { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { fetchUserFaqApi } from "services/faq";

const FAQS = () => {
  // Set all value
  const [faqList, setFaqList] = useState([]);

  const { i18n } = useTranslation();

  // const fetchFaqList = async (activePage) => {
  //   try {
  //     setShowFaqShrimmer(true);
  //     const sendData = {
  //       page: 1,
  //       limit: 5,
  //     };
  //     const responseData = await fetchUserFaqApi(sendData);
  //     const { data, status } = responseData;
  //     if (status === 200) {
  //       setFaqList(data?.faq || []);
  //     }
  //   } catch (e) {
  //     console.log("Error:", e.message);
  //   } finally {
  //     setShowFaqShrimmer(true);
  //   }
  // };

  // useEffect(() => {
  //   fetchFaqList();
  // }, []);

  return (
    <>
      <div className="faqs spacing">
        <div className="page_title">
          <h3>Frequently Asked Questions</h3>
        </div>
        <div className="accordion_wrap">
          <Accordion defaultActiveKey="0">
            {faqs.map(({ title, description, _id }, index) => {
              return (
                <Accordion.Item eventKey={String(index)}>
                  <Accordion.Header>{title[i18n.language]}</Accordion.Header>
                  <Accordion.Body>{description[i18n.language]}</Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        </div>
      </div>
    </>
  );
};

export default FAQS;
